document.addEventListener("DOMContentLoaded", function() {
  var btn = document.getElementById("scrollToTop");
  if (!btn) return;

  window.addEventListener("scroll", function() {
    if (window.scrollY > 300) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  });

  btn.addEventListener("click", function() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});



  document.addEventListener("DOMContentLoaded", function() {
    const sr = ScrollReveal({
      distance: '50px',
      duration: 800,
      easing: 'ease-in-out',
      reset: false 
    });

    sr.reveal('.shopify-section:not(header, #shopify-section-template--20457903751387__section_Wtwihn, #shopify-section-template--20568912396507__hero_jEt9dd, #shopify-section-template--20568912593115__product-information, #shopify-section-template--20457903947995__media_with_content_3R3mTy, #shopify-section-template--20457903947995__product_recommendations_8RVdzU, .shopify-section-group-footer-group, #shopify-section-template--20568515707099__hero_iYye6U, #shopify-section-template--20568515641563__hero_iGyxiL, #shopify-section-template--20568515510491__hero_jEt9dd)', {
      origin: 'bottom',
      interval: 100
    });

    const revealBlocks = {
      /*header: {
        selector: '#shopify-section-header',
        options: { origin: 'top', distance: '80px', duration: 600 }
      },*/
      footer: {
        selector: '#shopify-section-footer',
        options: { origin: 'bottom', distance: '40px', duration: 600 }
      },
      /*productCards: {
        selector: '.product-card',
        options: { origin: 'bottom', distance: '50px', interval: 200, duration: 600, viewFactor: 0.01, reset: false, mobile: true }
      },*/
      images: {
        selector: '.image-block',
        options: { origin: 'left', distance: '100px', duration: 700 }
      }
    };
    
    Object.values(revealBlocks).forEach(block => {
      sr.reveal(block.selector, block.options);
    });


function getCardsToAnimate() {
  const allCards = Array.from(document.querySelectorAll('.product-card'));
  const screenWidth = window.innerWidth;

  if (screenWidth < 768) {
    return allCards.slice(0, 2);
  } else {
    return allCards.slice(0, 5);
  }
}

let cardsToReveal = getCardsToAnimate();

sr.reveal(cardsToReveal, {
  origin: 'bottom',
  distance: '50px',
  interval: 100,
  duration: 600,
  viewFactor: 0.01
});

window.addEventListener('resize', () => {
  cardsToReveal = getCardsToAnimate(); 
});

});


function initTestimonialsSlider() {
  const slider = document.querySelector('#testimonialsSlider');
  if (slider && !slider.classList.contains('is-initialized') && typeof Splide !== 'undefined') {
    new Splide(slider, {
      type: 'loop',
      autoplay: true,
      interval: 4000,
      pauseOnHover: true,
      pauseOnFocus: false,
      perPage: 3,
      perMove: 1,
      gap: '20px',
      drag: true,
      focus: 'center',
      flickPower: 400,
      flickVelocity: 0.5,
      speed: 600,
      easing: 'cubic-bezier(0.25, 1.5, 0.5, 1)',
      breakpoints: {
        1024: { perPage: 2 },
        768:  { perPage: 1 }
      },
      trimSpace: false,
      pagination: false,
      arrows: true
    }).mount();

    slider.classList.add('is-initialized');
  }
}
const sliderInterval = setInterval(() => {
  initTestimonialsSlider();
}, 200);
document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
document.addEventListener('shopify:section:load', initTestimonialsSlider);





document.addEventListener('DOMContentLoaded', () => {
  const firstFAQ = document.querySelector('.accordion .details');
  if (firstFAQ) firstFAQ.setAttribute('open', '');
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/products/')) {
    const accordions = document.querySelectorAll('.accordion');
    if (accordions.length > 1) {
      const secondAccordion = accordions[1];
      
      document.querySelectorAll('.accordion .details').forEach(d => d.removeAttribute('open'));
      
      const firstDetail = secondAccordion.querySelector('.details');
      if (firstDetail) firstDetail.setAttribute('open', '');
    }
  }
});



// 1) Postavi target na već postojeće prave eksterne linkove (http/https)
document.querySelectorAll('a[href^="http"]').forEach(link => {
  try {
    const url = new URL(link.href, location.href);
    if (url.hostname !== location.hostname) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  } catch (e) { /* ignore invalid URLs */ }
});

// 2) Klik handler koji radi i na iOS-u, ali sa gardovima
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href]');
  if (!link) return;

  // --- SKIP: Judge.me i slični widgeti (ne diramo njihove klikove)
  if (
    link.closest('.jdgm-widget') ||       // bilo koji Judge.me widget
    link.classList.contains('jdgm-write-review') ||
    link.hasAttribute('data-jdgm-link') ||
    link.dataset.jdgm === 'true'
  ) {
    return; // pusti njihov default
  }

  const href = link.getAttribute('href') || '';

  // --- SKIP: pseudo linkovi ili specijalni protokoli
  if (
    href === '#' ||
    href.startsWith('javascript:') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')
  ) {
    return;
  }

  // Reaguj samo na apsolutne http/https URL-ove
  if (!/^https?:\/\//i.test(href)) {
    return; // relativne rute (unutrašnje) pusti default
  }

  // Proveri domen – samo spojašnji u novi tab
  let url;
  try {
    url = new URL(href, location.href);
  } catch (e2) { return; }

  if (url.hostname === location.hostname) {
    return; // naš domen – ništa ne menjaj
  }

  // Eksterni http/https link → otvori u novom tabu (radi i na iOS Safari)
  e.preventDefault();
  window.open(url.toString(), '_blank', 'noopener,noreferrer');
});


